import React, { BaseSyntheticEvent, useRef, useState } from "react";
import { Button, Typography } from "@optimizely/axiom";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag/useFeatureFlag";
import { Flags } from "../../../feature-flags/flags";

interface IUploadButtonProps {
    className?: string;
    disabled?: boolean;
    children?: any;
    onSelection: (file: File) => void;
    extensions?: string;
    isLoading?: boolean;
    loadingText?: string;
    leftIcon?: string;
}

export const UploadButton = ({
    className,
    disabled = false,
    onSelection,
    children = "Select a File",
    extensions,
    isLoading = false,
    loadingText = children,
    leftIcon
}: IUploadButtonProps) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [fileName, setFileName] = useState<string | null>(null);
    const { enabled: enableRebrand } = useFeatureFlag(Flags.ENABLE_REBRAND);
    const triggerFileClick = () => {
        const button = inputRef.current;

        if (button) {
            button.click();
        }
    };

    const handleFileSelection = (e: BaseSyntheticEvent) => {
        const [file] = e.target.files;
        const { name } = file;
        setFileName(name);
        onSelection(file);
    };

    return (
        <>
            <input
                ref={inputRef}
                accept={extensions}
                style={{ position: "absolute", left: "-1000px" }}
                type="file"
                onChange={handleFileSelection}
            />
            <div className="flex flex-align--center">
                <Button
                    // eslint-disable-next-line react/style-prop-object
                    style={enableRebrand ? "highlight" : undefined}
                    className={className}
                    isDisabled={disabled}
                    onClick={triggerFileClick}
                    isLoading={isLoading}
                    loadingText={loadingText}
                    leftIcon={leftIcon as any}
                >
                    {children}
                </Button>
                <Typography className="push--left" type="body">
                    {fileName}
                </Typography>
            </div>
        </>
    );
};
